import { useQuery } from '@apollo/client';
import { AtomicAccountsDocument } from '../../graphql/generated';

export const useExportActionText = () => {
    const { data: atomicAccountsData, loading: atomicAccountsLoading } =
        useQuery(AtomicAccountsDocument);

    if (atomicAccountsLoading || !atomicAccountsData?.atomicAccounts) {
        return 'Export';
    }

    return atomicAccountsData.atomicAccounts.length > 0
        ? 'Export & Withdraw'
        : 'Export & Close';
};
